import { useState } from "react";
import { Twitter, Linkedin, Link2, Check } from "lucide-react";

// Compact share row placed after an article body. Uses the canonical site URL
// + a #article-{slug} anchor so recipients land right on the article.
export default function ShareRow({ slug, title, testIdPrefix = "share" }) {
    const [copied, setCopied] = useState(false);

    const url = (() => {
        if (typeof window === "undefined") return "";
        return `${window.location.origin}/#article-${slug}`;
    })();

    const shareText = `${title} — The Equity Nation`;

    const twitterHref = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        shareText,
    )}&url=${encodeURIComponent(url)}`;
    const linkedinHref = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        url,
    )}`;

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 1800);
        } catch {
            // fallback: no toast library — silently fail
        }
    };

    return (
        <div
            data-testid={`${testIdPrefix}-row`}
            className="mt-10 md:mt-12 pt-6 border-t border-[color:var(--charcoal)]/15 flex flex-wrap items-center gap-3 md:gap-4"
        >
            <span className="font-mono font-semibold text-[12px] uppercase tracking-[0.24em] text-[color:var(--slate)]">
                Share this article
            </span>
            <div className="flex items-center gap-2 flex-wrap">
                <a
                    href={twitterHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`${testIdPrefix}-x`}
                    aria-label="Share on X / Twitter"
                    className="pill-btn ghost"
                    style={{ padding: "0.55rem 1rem" }}
                >
                    <Twitter size={13} strokeWidth={1.6} />
                    X
                </a>
                <a
                    href={linkedinHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`${testIdPrefix}-linkedin`}
                    aria-label="Share on LinkedIn"
                    className="pill-btn ghost"
                    style={{ padding: "0.55rem 1rem" }}
                >
                    <Linkedin size={13} strokeWidth={1.6} />
                    LinkedIn
                </a>
                <button
                    type="button"
                    onClick={copyLink}
                    data-testid={`${testIdPrefix}-copy`}
                    aria-label="Copy article link"
                    className="pill-btn ghost"
                    style={{ padding: "0.55rem 1rem" }}
                >
                    {copied ? (
                        <>
                            <Check size={13} strokeWidth={1.7} />
                            Link copied
                        </>
                    ) : (
                        <>
                            <Link2 size={13} strokeWidth={1.6} />
                            Copy link
                        </>
                    )}
                </button>
            </div>
        </div>
    );
}
